import React from 'react';
import { GrMapLocation } from "@react-icons/all-files/gr/GrMapLocation";
import parse from 'html-react-parser';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { getAnalytics, logEvent } from "firebase/analytics";

function LogBc(props) {
    try {
        logEvent(getAnalytics(), 'select_content', {
            content_type: 'video',
            content_id: props.app.name
        });
    } catch (e) {}
    return null; // Obligatoire dans React pour ne pas faire planter l'affichage
}

function PopUpVideo(app) {
    // 1. Si aucune vidéo n'est renseignée, on affiche l'image en grand
    if (!app.app.video || app.app.video === "#" || app.app.video === "") {
        return (
            <Popup trigger={<button> <img src={app.app.logo} className='logo app-logo' alt='image'/>{app.app.plus}</button>} position="right center">
                <img src={app.app.logo} alt={app.app.name} style={{ maxWidth: '800px', width: '100%', height: 'auto' }} />
            </Popup>
        );
    }

    // 2. Si c'est une vidéo : ton code EXACT d'origine
    return (
        <Popup trigger={<button> <LogBc app={app.app}/> <img src={app.app.logo} className='logo app-logo' alt='video'/>{app.app.plus}</button>} position="right center">
            <iframe src={app.app.video} className="video" />
        </Popup>
    );
}

function Company(exp) {
    const { experience } = exp;
    const logoClass = experience.logo ? 'logo' : 'comp-name';

    return (
        <span className={logoClass}>
      {experience.url && experience.logo ? (
          <a href={experience.url} target="_blank" rel="noreferrer">
              <img src={experience.logo} alt={experience.companyName} height={40} />
          </a>
      ) : experience.logo ? (
          <img src={experience.logo} alt={experience.companyName} height={40} />
      ) : (
          <span>{experience.companyName}</span>
      )}
    </span>
    );
}

function Period(exp) {
    if (exp.experience != null && exp.experience.endDate != null && exp.experience.endDate.trim() === '')
        return <span className="dates">{exp.experience.startDate}</span>;
    else if(exp.experience.endDate == null || exp.experience.endDate.trim() === '')
        return <span className="dates">Depuis {exp.experience.startDate}</span>;
    return <span className="dates">{exp.experience.startDate} > {exp.experience.endDate}</span>;
}

function Experience(exp) {
    return (
        <span className="role">
      <b>{exp.experience.job}</b>
      <span className={'role-type'}>{exp.experience.type ?? ''}</span>
    </span>
    );
}

function Gogole(exp) {
    var link = "https://www.google.com/maps/place/" + exp.experience.location;
    return (
        <span>
      <a href={link} target="_blank" rel="noreferrer">
        <GrMapLocation className="loc-icon" color="green" />
      </a>
    </span>
    );
}

function Location(exp) {
    return (
        <div className="area">
            <Gogole experience={exp.experience} />
            <span className="loc">{exp.experience.location}</span>
        </div>
    );
}

function Apps(exp) {
    if (exp.experience.Apps != null)
        return (
            <div className='apps'>
                {exp.experience.Apps.map(function (app, i) {
                    return (
                        <span className='app' key={i}>
              <PopUpVideo app={app} />
            </span>
                    );
                })}
            </div>
        );
    return null;
}

function Experiences(props) {
    const { data,keys } = props

    return (
        <div className="experiences">
            <div className="section-header"><h4>{keys.experiences}</h4></div>
            {data.Experiences.map((experience, i) => {
                return (
                    <div className="experience card" id={i} key={i}>
                        <Company experience={experience} />
                        <div className="exp">
                            <Experience experience={experience} />
                            <Period experience={experience} />
                        </div>
                        <div>
                            <Location experience={experience} />
                            {experience.roles && experience.roles.length > 0 && (
                                <ul>
                                    {experience.roles.map(function (role, j) {
                                        return (
                                            <li key={j}>
                                                {parse(role.description)}
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                        <Apps experience={experience} />
                    </div>
                );
            })}
        </div>
    );
}

export default Experiences;